import { FC } from 'react';

import accountsControlCreateButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/accounts_control/accounts_control_create_button_click';
import { Button, useBreakpoint } from '@hh.ru/magritte-ui';
import { Link as SPALink } from '@hh.ru/redux-spa-middleware';

import useTrls from 'hooks/translation/useTrls';

export const AccountCreateButton: FC = () => {
    const trl = useTrls();
    const { isGtS } = useBreakpoint();

    return (
        <Button
            Element={SPALink}
            to="/new/account/create/"
            onClick={() => accountsControlCreateButtonClick()}
            mode="primary"
            style="accent"
            size={isGtS ? 'medium' : 'small'}
            data-qa="create-new-cabinet"
        >
            {trl('accounts.control.create')}
        </Button>
    );
};
